/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useState } from 'react';
import { Actionable, Dropdown, Text } from '@az/starc-ui';
import styles from './styles.module.scss';
import { useBvPixelTracking } from '../../hooks/useBvPixelTracking';
import { useLabels } from '@/hooks/useLabels';

type SortOption = {
  label: string;
  value: string;
};

const labelMap = {
  sortBy: 'label_reviews_sortBy',
};

type SortByDropdownProps = {
  sortOptions: SortOption[];
  onSortChange?: (value: string) => void;
};

const SortByDropDown = ({ sortOptions, onSortChange }: SortByDropdownProps) => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<SortOption | undefined>(sortOptions[0]);
  const { trackEvent } = useBvPixelTracking();
  const labels = useLabels(labelMap);

  const handleSortChange = (option: SortOption) => {
    setSelectedOption(option);
    onSortChange?.(option.value);
    trackEvent('Sort By', 'Click', 'Filter', option.value);
    setOpen(false);
  };

  return (
    <Dropdown
      placement="bottom-end"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      className={styles.reviewDropdown}
    >
      <Dropdown.Button className={styles.dropdownButton}>
        <Text className={styles.dropdownButtonText}>{selectedOption?.label || labels.sortBy}</Text>
      </Dropdown.Button>
      <Dropdown.Content className={styles.options}>
        {open && (
          <ul>
            {sortOptions.map((option) => (
              <li key={option.value} className={styles.sortByDropDownOptions}>
                <Actionable onClick={() => handleSortChange(option)}>
                  <Text className={styles.sortOption}>{option.label}</Text>
                </Actionable>
              </li>
            ))}
          </ul>
        )}
      </Dropdown.Content>
    </Dropdown>
  );
};

export default SortByDropDown;
